// extracted by mini-css-extract-plugin
export default {"entriesTitle":"IGFEntryView_entriesTitle__FiIvM","entriesWrapper":"IGFEntryView_entriesWrapper__ptxyk"};